import { configureStore } from '@reduxjs/toolkit';
import navigationReducer from '../features/navigation/navigationSlice';
import blogReducer from '../features/blog/blogSlice';

export const store = configureStore({
  reducer: {
    navigation: navigationReducer,
    blog: blogReducer,
  },
});

export default store; 